import { render, staticRenderFns } from "./Etapa1.vue?vue&type=template&id=709f4bf3&scoped=true"
import script from "./Etapa1.vue?vue&type=script&lang=js"
export * from "./Etapa1.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=709f4bf3&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709f4bf3",
  null
  
)

export default component.exports